export const blogPostListingPlaceholder = '%BLOG_POST_LISTING%'
export const blogPostTitlePlaceholder = '%BLOG_POST_TITLE%'
export const blogPostDescriptionPlaceholder = '%BLOG_POST_DESCRIPTION%'
export const blogPostImageUrlPlaceholder = '%BLOG_POST_IMAGE_URL%'
export const blogPostDateTsPlaceholder = '%BLOG_POST_DATE_TS%'
export const blogPostCategoriesPlaceholder = '%BLOG_POST_CATEGORIES%'
export const blogPathPlaceholder = '%BLOG_PATH%'
export const blogLayoutPageIdPlaceholder = '%BLOG_LAYOUT_PAGE_ID%'
export const blogCategoryTitlePlaceholder = '%BLOG_CATEGORY_TITLE%'
export const blogCategoryDescriptionPlaceholder = '%BLOG_CATEGORY_DESCRIPTION%'

export const defaultState = {
  blogPostListing: blogPostListingPlaceholder,
  blogPostTitle: blogPostTitlePlaceholder,
  blogPostDescription: blogPostDescriptionPlaceholder,
  blogPostImageUrl: blogPostImageUrlPlaceholder,
  blogPostDateTs: blogPostDateTsPlaceholder,
  blogPostCategories: blogPostCategoriesPlaceholder,
  blogPath: blogPathPlaceholder,
  blogLayoutPageId: blogLayoutPageIdPlaceholder,
  blogCategoryTitle: blogCategoryTitlePlaceholder,
  blogCategoryDescription: blogCategoryDescriptionPlaceholder,
  blogSearch: [],
}

export default function (state = defaultState) {
  return state
}

export const getBlogCategoryTitle = state => {
  if (state.blogCategoryTitle === blogCategoryTitlePlaceholder) {
    return null
  }

  return state.blogCategoryTitle
}

export const getBlogCategoryDescription = state => {
  if (state.blogCategoryDescription === blogCategoryDescriptionPlaceholder) {
    return null
  }

  return state.blogCategoryDescription
}

export const getBlogPostTitle = ({ blogPostTitle }) => blogPostTitle

export const getBlogPostDescrition = ({ blogPostDescription }) =>
  blogPostDescription

export const getBlogPostImageUrl = ({ blogPostImageUrl }) => blogPostImageUrl

export const getBlogPostDate = ({ blogPostDateTs }) =>
  new Date(blogPostDateTs * 1000)

export const getBlogPostListing = ({ blogPostListing }) => {
  try {
    return JSON.parse(blogPostListing)
    // biome-ignore lint/correctness/noUnusedVariables: <explanation>
  } catch (e) {
    return {
      posts: [],
      pagination: {
        current: 0,
        total: 0,
      },
    }
  }
}

export const getBlogPostCategories = ({ blogPostCategories }) => {
  try {
    return JSON.parse(blogPostCategories)
    // biome-ignore lint/correctness/noUnusedVariables: <explanation>
  } catch (e) {
    return []
  }
}

export const getBlogPath = ({ blogPath }) => blogPath

const getBlogLayoutPageId = state => state.blogLayoutPageId

export const selectors = {
  getBlogLayoutPageId,
  getBlogPostImageUrl,
  getBlogPath,
  getBlogPostTitle,
  getBlogPostCategories,
  getBlogPostDate,
  getBlogPostListing,
  getBlogCategoryTitle,
  getBlogCategoryDescription,
}
